import { apiFetch } from './apiClient';

/* A senha NUNCA vem na listagem -- só `temSenha`, pra tela saber se mostra
   os botões de ver/copiar. O texto em claro é pedido na hora do clique
   (buscarSenhaNfCliente), e cada consulta dessas fica registrada na
   auditoria do backend. */
export const listarNfClientes = () => apiFetch('/nf-clientes');

export const salvarAcessoNfCliente = (clienteId, dados) =>
  apiFetch(`/nf-clientes/${clienteId}`, { method: 'PUT', body: JSON.stringify(dados) });

export async function buscarSenhaNfCliente(clienteId) {
  const { senha } = await apiFetch(`/nf-clientes/${clienteId}/senha`);
  return senha;
}

export const removerSenhaNfCliente = (clienteId) =>
  apiFetch(`/nf-clientes/${clienteId}/senha`, { method: 'DELETE' });
